import {
  init,
  isTMA,
  miniApp,
  openLink,
  openTelegramLink,
  retrieveRawInitData,
  themeParams,
  viewport,
} from '@tma.js/sdk'

/** True inside Telegram (Mini App); false in a regular browser. Decided once at startup. */
export const inTelegram: boolean = (() => {
  try {
    return isTMA()
  } catch {
    return false
  }
})()

/** Wires the SDK: theme, safe areas, full height. Safe to call outside Telegram (no-op). */
export function setupTelegram(): void {
  if (!inTelegram) return
  init()
  if (miniApp.mount.isAvailable()) miniApp.mount()
  if (themeParams.mount.isAvailable()) themeParams.mount()
  if (viewport.mount.isAvailable()) {
    void viewport.mount().then(() => {
      // Exposes --tg-viewport-content-safe-area-inset-* for the layout.
      if (viewport.bindCssVars.isAvailable()) viewport.bindCssVars()
      if (viewport.expand.isAvailable()) viewport.expand()
    })
  }
  if (miniApp.ready.isAvailable()) miniApp.ready()
}

export function telegramInitData(): string | undefined {
  return inTelegram ? retrieveRawInitData() : undefined
}

/** Telegram's own light/dark — what "Как в системе" means inside the Mini App. */
export function telegramIsDark(): boolean | undefined {
  if (!inTelegram || !miniApp.isMounted()) return undefined
  return miniApp.isDark()
}

/** Opens a chat link in Telegram's browser (t.me links inside Telegram); false outside the Mini App. */
export function openExternalLink(url: string): boolean {
  if (!inTelegram) return false
  if (/^https:\/\/t\.me\//i.test(url) && openTelegramLink.isAvailable()) {
    openTelegramLink(url)
    return true
  }
  if (openLink.isAvailable()) {
    openLink(url)
    return true
  }
  return false
}
